import { Module } from '../Module';

/**
 * A drop-in replacement for angular-translate's `<translate>` directive
 * that uses Localize under the hood instead. Should behave exactly as
 * the `<translate>` directive does. myork literally copied and pasted
 * the angular-translate directive, but this uses our Localize-backed
 * $translate service under the hood
 */
Module.instance().directive('translate', <any[]>[
  '$translate',
  '$q',
  '$interpolate',
  '$compile',
  '$parse',
  '$rootScope',
  function(
    $translate: ng.translate.ITranslateService,
    $q: ng.IQService,
    $interpolate: ng.IInterpolateService,
    $compile: ng.ICompileService,
    $parse: ng.IParseService,
    $rootScope: ng.IRootScopeService) {
    return {
      restrict: 'AE',
      scope: true,
      compile: function(tElement: JQuery, tAttr: ng.IAttributes) {
        const translateValuesExist = tAttr.translateValues ? tAttr.translateValues : undefined;
        const translateInterpolation = tAttr.translateInterpolation ? tAttr.translateInterpolation : undefined;
        const translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
        const interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)';
        return function linkFn(scope: any, iElement: JQuery, iAttr: ng.IAttributes) {
          scope.interpolateParams = {};
          scope.preText = '';
          scope.postText = '';
          iAttr.$observe('translate', function(translationId: String) {
            translationId = translationId.trim();
            if (angular.equals(translationId, '') || !angular.isDefined(translationId)) {
              const interpolateMatches = iElement.text().match(interpolateRegExp);
              if (angular.isArray(interpolateMatches)) {
                scope.preText = interpolateMatches[1];
                scope.postText = interpolateMatches[3];
                scope.translationId = $interpolate(interpolateMatches[2])(scope.$parent);
              } else {
                scope.translationId = iElement.text().replace(/^\s+|\s+$/g, '');
              }
            } else {
              scope.translationId = translationId;
            }
          });
          iAttr.$observe('translateDefault', function(value: String) {
            scope.defaultText = value.trim();
          });
          if (translateValuesExist) {
            iAttr.$observe('translateValues', function(interpolateParams: string) {
              interpolateParams = interpolateParams.trim();
              if (interpolateParams) {
                scope.$parent.$watch(function() {
                  angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
                });
              }
            });
          }
          if (translateValueExist) {
            const fn = function(attrName: string) {
              iAttr.$observe(attrName, function(value: String) {
                scope.interpolateParams[attrName.substr(14, 1).toLowerCase() + attrName.substr(15)] = value.trim();
              });
            };
            for (const attr in iAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                fn(attr);
              }
            }
          }
          const applyElementContent = function(value: any, scope: any, successful: boolean) {
            if (!successful && typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
            iElement.html(scope.preText + value + scope.postText);
            const globallyEnabled = $translate.isPostCompilingEnabled();
            const locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            const locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if (globallyEnabled && !locallyDefined || locallyEnabled) {
              const elementContents = iElement.contents() as any as JQuery;
              $compile(elementContents)(scope);
            }
          };
          const updateTranslationFn = function() {
              if (!translateValuesExist && !translateValueExist) {
                return function() {
                  const unwatch = scope.$watch('translationId', function(value: string) {
                      if (scope.translationId && value) {
                        $translate(value, {}, translateInterpolation).then(function(translation) {
                          applyElementContent(translation, scope, true);
                          unwatch();
                        }, function(translationId) {
                          applyElementContent(translationId, scope, false);
                          unwatch();
                        });
                      }
                    }, true);
                };
              } else {
                return function() {
                  const updateTranslations = function() {
                    if (scope.translationId && scope.interpolateParams) {
                      $translate(scope.translationId, scope.interpolateParams, translateInterpolation).then(function(translation) {
                        applyElementContent(translation, scope, true);
                      }, function(translationId) {
                        applyElementContent(translationId, scope, false);
                      });
                    }
                  };
                  scope.$watch('interpolateParams', updateTranslations, true);
                  scope.$watch('translationId', updateTranslations);
                };
              }
            }();
          const unbind = $rootScope.$on('$translateChangeSuccess', updateTranslationFn);
          updateTranslationFn();
          scope.$on('$destroy', unbind);
        };
      }
    };
  }
]);
